module.exports = __webpack_public_path__ + "img/toptitle.47f9865f.png";